import { createInstance } from "@shuttlerock/i18n";
import de from "./de.yml";
import en from "./en.yml";
import ja from "./ja.yml";

/**
 * The design system's own catalogue.
 *
 * Namespaces here are named after the component rather than a feature domain
 * (the convention in `ui/docs/workspace-conventions.md`), because the kit has no
 * feature domain — the component *is* the unit that owns its copy.
 *
 * Keep this small. A string belongs here only when the kit renders it with no
 * useful consumer variation; anything a caller would want to word differently
 * stays a slot.
 */
export const { i18n, useTranslation, Trans } = createInstance({ en, de, ja });

i18n.init();

export default i18n;
